module.exports = __webpack_public_path__ + "static/img/3-info-b8.6fb9d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b8.jpg
// module id = M2Cl
// module chunks = 0